const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/dr-dan`;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('dentalToken')}`, 'Content-Type': 'application/json' });

const json = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || 'Request failed');
  return data;
};

export const drDanApi = {
  sessions: () => fetch(`${BASE}/sessions`, { headers: headers() }).then(json),
  session: (id) => fetch(`${BASE}/sessions/${id}`, { headers: headers() }).then(json),
  remove: (id) => fetch(`${BASE}/sessions/${id}`, { method: 'DELETE', headers: headers() }).then(json),
  async chat(message, sessionId, onEvent) {
    const res = await fetch(`${BASE}/chat`, { method: 'POST', headers: headers(), body: JSON.stringify({ message, sessionId }) });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.detail || 'Dr. Dan is unavailable right now. Please try again.');
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = '';
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      const parts = buf.split('\n\n');
      buf = parts.pop();
      parts.forEach((p) => p.startsWith('data: ') && onEvent(JSON.parse(p.slice(6))));
    }
  },
};
